/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { KontaktePromptInsert } from '../models/KontaktePromptInsert';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class KontaktePromptInsertsService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Alle Prompt Inserts abrufen
   * Gibt alle Prompt Inserts für alle Kontakte zurück
   * @returns KontaktePromptInsert Liste aller Prompt Inserts
   * @throws ApiError
   */
  public getAllKontaktePromptInserts(): CancelablePromise<Array<KontaktePromptInsert>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/kontakte-prompt-inserts',
      errors: {
        401: `Unauthorized for this request`,
        403: `Forbidden for this request`,
      },
    });
  }

}
